import { render, staticRenderFns } from "./ORTBasePage.vue?vue&type=template&id=82da7124&scoped=true"
import script from "./ORTBasePage.vue?vue&type=script&lang=js"
export * from "./ORTBasePage.vue?vue&type=script&lang=js"
import style0 from "./ORTBasePage.vue?vue&type=style&index=0&id=82da7124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da7124",
  null
  
)

export default component.exports